module.exports = __webpack_public_path__ + "img/Icon.4478f7ac.png";